import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDeleteLineItemStyles = makeStyles({
    root: {
        display: 'grid',
        justifyItems: 'end'
    },
    deleteIcon: {
        boxSizing: 'border-box',
        color: tokens.colorNeutralForeground4,
        display: 'flex',
        width: '20px',
        height: '20px',
        ...shorthands.margin('6px', '0'),
        cursor: 'pointer'
    }
});
